module.exports = __webpack_public_path__ + "fonts/source-code-pro-v22-latin-600.b94534eb.woff";